// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"429":"10f09eab","673":"30266fd2","782":"d81e8f17","934":"94e28a8d"}[chunkId] + ".chunk.js";
};